import store from "~/js/store/store";
import { gsap, Cubic } from "gsap";
export default class ArrivalNotificationModal {
  constructor() {
    this.contents = document.querySelector('.back-in-stock-popup');

    /*this.open = document.querySelectorAll('.f-arrivalNotificationOpen');
    this.close = document.querySelectorAll('.f-arrivalNotificationClose');

    this.checkbox = this.contents.querySelector('.f-checkbox');
    this.submit = this.contents.querySelector('._submit');*/

    this.isOpen = false;
    
    this.setup()
  }

  setup () {

    // Page Loaded
    this._themeLoaded(() => {
      const BISDefaultOptions = {
        addInStockButtonSelector: '#BIS_add_in_stock',
        defaultImageSelector: '._gallery ._photo.on img'
      }
      const option = JSON.parse(document.getElementById('backInStockJson').innerHTML);
      this.BIS = BIS;
      this.BISConfig = _BISConfig;
      this.productSelectedObject = {};
      this.variantSelected = {};
      this.options = Object.assign(BISDefaultOptions, option);
      this.elements = this._getElements();

      // Initialization
      this._bis_init();
    });

    store.subscribe(((mutation, state) => {

      if(store.getters['arrivalNotificationModal']())
      {
        if(!this.isOpen)
        {
          this.isOpen = true;

          gsap.to(this.contents, {
            display: "block",
            opacity: 1,
            duration: 0.3,
            ease: Cubic.easeInOut
          });
          gsap.fromTo(
            this.container,
            {
              marginTop: 30
            },
            {
              marginTop: 0,
              duration: 0.6,
              ease: Cubic.easeOut
            }
          );
          setTimeout(function()
          {
            this.contents.focus();
          }.bind(this), 300);
        }
      }
      else
      {
        if(this.isOpen)
        {
          this.isOpen = false;

          gsap.to(this.contents, {
            display: "none",
            opacity: 0,
            duration: 0.3,
            ease: Cubic.easeInOut
          });
          gsap.fromTo(
            this.container,
            {
              marginTop: 0
            },
            {
              marginTop: 30,
              duration: 0.3,
              ease: Cubic.easeIn
            }
          );
        }
      }
    }));

  }

  _getElements() {
    return {
      addInStockButton: document.querySelector(this.options.addInStockButtonSelector),
    };
  }

  _bis_init() {
    this.BIS.popup.ready.then(() => {
      if (!this.BIS.popup?.variants.length < 1) {
        // Select the variant in popup form.
        this._setupEventSelectVariantPopup();
      }
    });
  }

  _setupEventSelectVariantPopup() {
    this.elements.addInStockButton.addEventListener('click', () => {
      let variantDefault = document.querySelector('[name="id"]').value;
      this.variantSelected = this.BIS.popup._variantsById[variantDefault];

      if (this.BIS.popup.variantIsUnavailable(this.variantSelected)) {
        this.productSelectedObject = this._productSelectedObject();
        this.productSelectedObject.optionSelected = this._getVariantOptions();
        this.productSelectedObject.variantSelected = this.variantSelected;

        this.container = this.contents.querySelector('.fs-c-modal__inner');

        this.contents.modifyContent(this.productSelectedObject);
        this.contents.setValidate(this.BIS, this.options, this.variantSelected.id, this.productSelectedObject.id);

        this.contents.querySelector('#BIS_popup_close').addEventListener('click', () => {
          store.dispatch('setArrivalNotificationModal', {
            sta: false
          });
        });

        this.contents.querySelector('.f-arrivalNotificationClose').addEventListener('click', () => {
          store.dispatch('setArrivalNotificationModal', {
            sta: false
          });
        });

        this.submit = this.contents.querySelector('#BackInStockPopupSubmit')
        this.checkbox = this.contents.querySelector("#arrival_notification_privacypolicy")

        this.checkbox.addEventListener('change', (event) => {
          if(this.checkbox.checked)
          {
            this.submit.disabled = false;
          }
          else
          {
            this.submit.disabled = true;
          }
        });

        console.log(this.productSelectedObject)
        store.dispatch('setArrivalNotificationModal', {
          sta: true
        });
      }
    });
  }

  _productSelectedObject() {
    let defaultImage = document.querySelector(this.options.defaultImageSelector);
    let product = this.BISConfig.product || {}
    let image = defaultImage.getAttribute('src');
    image = image.replaceAll('&width=', '&width=500&widthOld=')
    product.featured_image = image

    return product;
  }

  _getVariantOptions() {
    let variantOptions = [];
    this.productSelectedObject = this._productSelectedObject();
    this.productSelectedObject.variantSelected = this.variantSelected;
    console.log(this.productSelectedObject.options)
    if (this.productSelectedObject.options) {
      this.productSelectedObject.options.forEach((option, index) => {
        let optionValue = this.productSelectedObject.variantSelected.options[index];
        if (optionValue !== 'Default Title') {
          variantOptions.push({
            optionName: option,
            optionValue
          });
        }
      });
    }

    return variantOptions;
  }

  /**
   * @param callback
   */
   _themeLoaded(callback) {
    if (!window.SwymCallbacks) {
      window.SwymCallbacks = [];
    }

    window.SwymCallbacks.push(() => {
      callback();
    });
  }

}

if (!customElements.get('back-in-stock-popup')) {
  class BackInStockPopup extends HTMLElement {

    constructor() {
      super();
    }

    setValidate(BIS, options, variantSelectedId, productSelectedId) {
      this.Options = options;
      this.variantSelectedId = variantSelectedId;
      this.productSelectedId = productSelectedId;

      this.querySelector('#BIS_popup_register').addEventListener('submit', this.onSubmitHandler.bind(this))
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      
      if (this.formIsValid()) {

        this.submit = this.querySelector('.button')

        this.submit.classList.add('loading');
        this.submit.querySelector('.loading-overlay__spinner').classList.remove('hidden');

        BIS.create(this.querySelector('[name="email"]').value, this.variantSelectedId, this.productSelectedId, {
          accepts_marketing: true,
          quantity_required: 1
        }).then(() => {
          this.querySelector(".fs-c-modal__inner").innerHTML = '<h3 class="complete">'+this.Options.messages.sendSuccess+'</h3>';

          setTimeout(() => {
            store.dispatch('setArrivalNotificationModal', {
              sta: false
            });
          }, 4000);
        });
      }
    }

    formIsValid() {
      let isValid = true;

      // Validate Email
      let emailElement = this.querySelector('[name="email"]');
      let emailErrorElement = this.querySelector('#email-error span');

      if (emailElement.value === '') {
        isValid = false;
        this.showError(emailElement, emailErrorElement, this.Options.messages.backInStockRequired);
      } else {
        let pattern = /^([^\x00-\x20\x22\x28\x29\x2c\x2e\x3a-\x3c\x3e\x40\x5b-\x5d\x7f-\xff]+|\x22([^\x0d\x22\x5c\x80-\xff]|\x5c[\x00-\x7f])*\x22)(\x2e([^\x00-\x20\x22\x28\x29\x2c\x2e\x3a-\x3c\x3e\x40\x5b-\x5d\x7f-\xff]+|\x22([^\x0d\x22\x5c\x80-\xff]|\x5c[\x00-\x7f])*\x22))*\x40([^\x00-\x20\x22\x28\x29\x2c\x2e\x3a-\x3c\x3e\x40\x5b-\x5d\x7f-\xff]+|\x5b([^\x0d\x5b-\x5d\x80-\xff]|\x5c[\x00-\x7f])*\x5d)(\x2e([^\x00-\x20\x22\x28\x29\x2c\x2e\x3a-\x3c\x3e\x40\x5b-\x5d\x7f-\xff]+|\x5b([^\x0d\x5b-\x5d\x80-\xff]|\x5c[\x00-\x7f])*\x5d))*(\.\w{2,})+$/;

        if (!pattern.test(emailElement.value)) {
          isValid = false;
          this.showError(emailElement, emailErrorElement, this.Options.messages.emailCheck);
        } else {
          this.removeError(emailElement, emailErrorElement);
        }
      }

      // Validate privacyAgree
      let privacyAgreeElement = this.querySelector('[name="privacyAgree"]');
      let privacyAgreeErrorElement = this.querySelector('#privacyAgree-error');
      if (!privacyAgreeElement.checked) {
        isValid = false;
        this.showError(privacyAgreeElement, privacyAgreeErrorElement, this.Options.messages.backInStockRequired);
      } else {
        this.removeError(privacyAgreeElement, privacyAgreeErrorElement);
      }

      return isValid;
    }

    /**
     * @param emailElement
     * @param errorElement
     * @param message
     */
    showError(emailElement, errorElement, message) {
      emailElement.classList.add('validation-error');
      errorElement.textContent = message;
    }

    /**
     * @param emailElement
     * @param errorElement
     */
    removeError(emailElement, errorElement) {
      emailElement.classList.remove('validation-error');
      errorElement.textContent = '';
    }

    modifyContent(data) {
      this.modalContentTemplate = this.querySelector('#BackInStockPopupContentTemplate');
      this.modalContent = this.querySelector('#BackInStockPopupContent');
      this.modalContent.innerHTML = this.modalContentTemplate.innerHTML;

      // Render Image
      if (data.variantSelected?.featured_media?.preview_image) {
        this.modalContent.querySelector('[data-image]').src = data.variantSelected.featured_media.preview_image.src;
      } else {
        this.modalContent.querySelector('[data-image]').src = data.featured_image;
      }

      // Render Title
      if (data.title) {
        this.modalContent.querySelector('[data-title]').textContent = data.title;
      }

      // Render Variant
      if (data.optionSelected?.length) {
        data.optionSelected.forEach((option) => {
          // generate Option
          let spanVariantOption = document.createElement('div');
          spanVariantOption.innerHTML = '<span>'+option.optionName+'</span>'+option.optionValue;

          this.modalContent.querySelector('[data-variant]').appendChild(spanVariantOption);
        })
      }
    }
  }

  customElements.define('back-in-stock-popup', BackInStockPopup);
}